<template lang="pug">
  .product-nutrition-facts
    .product-nutrition-facts__fact(v-for="fact in nutritionFacts")
      .product-nutrition-facts__fact-number {{ fact.value }}
      .product-nutrition-facts__fact-title {{ fact.name }}
</template>

<script>
  export default {
    name: 'ProductNutritionFacts',
    props: {
      nutritionFacts: Array,
    },
  };
</script>

<style scoped lang="scss">
  .product-nutrition-facts {
  }

  .product-nutrition-facts {
    display: flex;
    flex-wrap: wrap;
  }

  .product-nutrition-facts__fact {
    flex: 0 0 100%;
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    @include tablet-up {
      flex: 0 0 25%;
      margin-bottom: 30px;
    }
  }

  .product-nutrition-facts__fact-number {
    margin-right: 16px;
    width: 40px;
    height: 40px;
    color: $color-white;
    font-size: rem(12);
    font-weight: 500;
    line-height: 40px;
    text-align: center;
    background-color: var(--pdp-color);
    border-radius: 50px;
  }

  .product-nutrition-facts__fact-title {
    font-weight: 500;
    text-transform: capitalize;
  }
</style>
